<template class="chart">
  <b-table class="is-middle" :loading="downloads.loading" :data="downloads.data" :current-page="downloads.current_page"
    :per-page="downloads.per_page" :total="downloads.total" paginated backend-pagination pagination-position="bottom"
    @page-change="page => downloads.changePage(page)">
    <template slot-scope="props">
      <b-table-column custom-key="Profile picture" label="" width="80" centered>
        <b-tooltip :label="props.row.user.name">
          <router-link :to="'/users/' + props.row.user.id">
            <div class="image is-32x32">
              <img :src="props.row.user.profile" class="is-rounded" />
            </div>
          </router-link>
        </b-tooltip>
      </b-table-column>

      <b-table-column label="User">
        <div>{{ props.row.user.name }}</div>
        <small class="has-text-grey">{{ props.row.user.email }}</small>
      </b-table-column>

      <b-table-column label="Device" centered>
        <router-link v-if="props.row.progress.device" :to="'/devices/' + props.row.progress.device.id">
          <div>{{ props.row.progress.device.model }}</div>
        </router-link>
      </b-table-column>

      <b-table-column v-if="props.row.progress.device" label="Country" centered>
        <span class="has-text-grey">
          <flag-img :country="props.row.progress.device.ip_based_country_code"></flag-img>
        </span>
      </b-table-column>

      <b-table-column label="Downloaded at" centered>
        <div class="has-text-grey">
          <b-tooltip :label="props.row.created_at | dateTime ">
            <span class="has-text-grey">
              {{ props.row.created_at | date }}
            </span>
          </b-tooltip>
        </div>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>No download list.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>

export default {
  data() {
    return {
      downloads: new window.PaginatedRemoteCollection(
        `/admin/api/magazine/issues/${this.$route.params.id}/downloads`
      ).load()
    };
  }
};
</script>
